require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2007-09-26-amazon-mp-3-store-is-freaking-awesome.json") })
        }
      }, "path---articles-2007-09-26-amazon-mp-3-store-is-freaking-awesome");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2007-09-26-amazon-mp-3-store-is-freaking-awesome!./.cache/json/articles-2007-09-26-amazon-mp-3-store-is-freaking-awesome.json
// module id = 532
// module chunks = 231608221292675